import FallbackComponent from '@components/std-components/FallbackComponent'
import React, { lazy, Suspense } from 'react'

const OrigCardSizeSelectorPopupContent = lazy(() =>
  import('./CardSizeSelectorPopupContent').then(m => ({
    default: m.CardSizeSelectorPopupContent
  }))
)

export const CardSizeSelectorPopupContent = props => {
  return (
    <Suspense fallback={<FallbackComponent />}>
      <OrigCardSizeSelectorPopupContent {...props} />
    </Suspense>
  )
}
